import { Card } from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../Button/Button";
import { useStyles } from "./CredentialsCardStyles";
import { useTranslation } from "../../../../../hooks/useTranslation";
import BundleKey from "../../../../../translation/bundleKey";
import DocumentCard from "../DocumentCard/DocumentCard";
import { RoutePaths } from "../../../../../utils/Items";
import { useRegistroIngresoSession } from "../../../../../views/LogisticPark/RegistroIngreso/session/RegistroIngresoSessionContext";
import { RegistroIngresoNavigationState } from "../../../../../views/LogisticPark/RegistroIngreso/registroIngresoNavigation";
import { ScanDniNavigationState } from "../../../../../views/LogisticPark/ScanDNI/scanDniNavigation";
import { IBlackUser } from "../../../../../store/types/userTypes";
import { isFullAccessRestriction } from "../../../../../views/LogisticPark/RegistroIngreso/utils/blacklistRestriction";
import BlacklistDialog from "../../Dialog/BlacklistDialog";

const CredentialsCard = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const { findExistingTab, closeTab } = useRegistroIngresoSession();
  const [blockedData, setBlockedData] = useState<IBlackUser | null>(null);

  const handleManualSubmit = (values: { country: string; dni: string }, userData?: any) => {
    if (isFullAccessRestriction(userData?.blacklistedData)) {
      const tab = findExistingTab(values.dni, values.country, "entry");
      if (tab) closeTab(tab.id);
      setBlockedData(userData.blacklistedData);
      return;
    }

    const state: RegistroIngresoNavigationState = {
      mode: "entry",
      intent: "keep-session",
    };

    history.push({
      pathname: RoutePaths.LogisticParkEntryRegistration,
      state,
    });
  };

  const handleScanClick = () => {
    const state: ScanDniNavigationState = {
      mode: "entry",
      intent: "append-tab",
    };

    history.push({
      pathname: RoutePaths.LogisticParkScanDNI,
      state,
    });
  };

  return (
    <Card className={classes.card}>
      <div className={classes.btnScanWrapper}>
        <Button className={classes.btnScan} onClick={handleScanClick}>
          {t(BundleKey.CREDENTIALSCARD_SCAN)}
        </Button>
      </div>
      <div className={classes.documentWrapper}>
        <DocumentCard noBorder onSubmit={handleManualSubmit} mode="entry" />
      </div>
      <BlacklistDialog
        open={!!blockedData}
        blacklistedData={blockedData}
        onReject={() => setBlockedData(null)}
        onAllow={() => setBlockedData(null)}
      />
    </Card>
  );
};

export default CredentialsCard;
